import { branch } from './constants'
import WeaverService from 'Services/WeaverService'

MIGRATION_NODE = 'migrations'

writeAccessErrorMessage = (action) ->
  "
    Unable to #{action} project. %
    Write access is required to #{action} the project.
    Some functionality might not work as expected.
  "

migrationErrorMessage = (filename) ->
  "
    Unable to bootstrap project. %
    An error occured during the project bootstrap phase.
    The project encountered issues while executing the #{getVersionString(filename)} migration.
    Please contact the project adminstrator for more information.
  "

genericErrorMessage =
  "
    Unable to bootstrap project. %
    An error occured during the project bootstrap phase.
    Some functionality might not work as expected.
  "

skipMigrationMessage = (filename) ->
  "
    Checksums don't match for #{filename}...
    Did you make an accidental change to the migration file?
  "

getVersionString = (str) ->
  str.split('__')[0]

# Polyfill for require.context
require.context = (->)  unless require.context?

fileReq = require.context('!!file-loader!./migrations', false, /\.coffee$/)
req = require.context('./migrations', false, /\.coffee$/)

isMigrationFile = (filename) ->
  /\.coffee$/.test(filename)

getMigrationNode = ->
  try
    await new Weaver.Query(undefined, branch).restrict(MIGRATION_NODE).first()
  catch
    new Weaver.Node(MIGRATION_NODE)

orderFlywayVersions = (flywayVersions) ->
  semvers = flywayVersions.map((item) ->
    fragments = item.filename.split('_').filter((char) -> char isnt '_')
    majorVersion = fragments.shift().substr(1,1)
    [minorVersion] = fragments.filter(parseInt)
    minorVersion ?= 0
    item.version = [majorVersion, minorVersion].join('.')
    item
  )
  _.orderBy(semvers, 'version')

getMigrations = (migrationNode) ->
  versionedMigrations = []
  undoMigrations = []
  repeatableMigrations = []

  migrationFiles = req.keys().filter(isMigrationFile)

  for migration in migrationFiles
    filename = migration.replace('./', '')
    hash = fileReq(migration).default.replace('.coffee', '').replace('/', '')
    migrationFn = req(migration)

    checksum = migrationNode.get('data')?[filename]?.checksum

    if filename.startsWith('R')
      if checksum isnt hash
        repeatableMigrations.push({
          filename
          migrationFn
          checksum: hash
        })
    else if filename.startsWith('U')
      if not checksum?
        undoMigrations.push({
          filename
          migrationFn
          checksum: hash
        })
    else
      if not checksum?
        versionedMigrations.push({
          filename
          migrationFn
          checksum: hash
        })

  { versionedMigrations, undoMigrations, repeatableMigrations }

executeMigration = (migrationNode, filename, migrationFn, checksum, transaction) ->
  await migrationFn(transaction)
  migrationNode.set(
    'data',
    {
      (migrationNode.get('data') or {})...,
      [filename]: { filename, checksum }
    }
    { dataType: 'json', upsert: true }
  )
  await migrationNode.save({ transaction, branch })

bootstrap = ->
  try
    migrationNode = await getMigrationNode()
  catch
    throw new Error(writeAccessErrorMessage('initialize'))

  { versionedMigrations, undoMigrations, repeatableMigrations } = getMigrations(migrationNode)

  migrationsToExecute = versionedMigrations.length + undoMigrations.length + repeatableMigrations.length
  throw new Error(writeAccessErrorMessage('update')) if not await WeaverService.userCanEdit() and migrationsToExecute

  try
    await Weaver.Branch.createBranch(branch)
  catch
    console.warn '$config branch exists, skipping...'

  await Promise.mapSeries([
    orderFlywayVersions(versionedMigrations)...
    orderFlywayVersions(undoMigrations)...
    repeatableMigrations...
  ], ({ filename, migrationFn, checksum }) ->
    transaction = undefined
    try
      transaction = await Weaver.getInstance().startTransaction({ branch, ttl: 300000 })
      await executeMigration(migrationNode, filename, migrationFn, checksum, transaction)
      await transaction.commit()
    catch e
      # try to rollback (might have happend automatically)
      try
        await transaction.rollback()
      catch e
      console.error(e);
      throw new Error(migrationErrorMessage(filename))
  )

export {
  bootstrap
}
